exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.major-icon {\n    font-size: 5rem;\n}\n", ""]);

// exports
